import { useEffect } from "react";
import { useSetAtom } from "jotai";
import { clientAtom } from "@/utils/atoms/atomClient";
import useSingleZone from "@/features/zones/hooks/useSingleZone";

const useSetClient = (slug: string) => {
  const { zoneItem, loading: loadingZone } = useSingleZone(slug);
  const setCurrentClient = useSetAtom(clientAtom);

  useEffect(() => {
    if (!loadingZone && zoneItem) {
      setCurrentClient(zoneItem.theme);
    }
  }, [loadingZone, zoneItem, slug]);

  return { zoneItem, loadingZone };
};

export default useSetClient;
